import { Payload } from "@neworbit/redux-helpers";

import { ThunkDispatch } from "redux-thunk";

import { loadAndTrack } from "redux-request-loading";

import axios from "axios";

import { ApplicationState } from "../applicationState";

import { TaskCategory } from "./model";
import { LOAD_TASK_CATEGORIES_SUCCESS, LOAD_TASK_CATEGORIES } from "./actionTypes";

import { TaskCategoriesApi } from "./TaskCategoriesApi";

export type TaskCategoriesAction = Payload<TaskCategory[]> & { type: typeof LOAD_TASK_CATEGORIES_SUCCESS };

const buildLoadTaskCategories = (taskCategoriesApi: TaskCategoriesApi) => {
    return () => {
        return async (dispatch: ThunkDispatch<ApplicationState, undefined, TaskCategoriesAction>) => {
            const result = await loadAndTrack(dispatch, LOAD_TASK_CATEGORIES, taskCategoriesApi.getAll());
            dispatch(loadTaskCategoriesSuccess(result));
        };
    };
};

export const loadTaskCategories = buildLoadTaskCategories(new TaskCategoriesApi(axios));

const loadTaskCategoriesSuccess = (taskCategories: TaskCategory[]): TaskCategoriesAction => ({
    type: LOAD_TASK_CATEGORIES_SUCCESS,
    payload: taskCategories
});
